import { Typography, Box, useTheme } from "@mui/material";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant="h2"
        fontWeight="800"
        sx={{
          mb: "5px",
          mt: "20px",
          background: theme.palette.mode === 'dark'
            ? "linear-gradient(90deg, #ffffff 0%, #a1a4ab 100%)"
            : "linear-gradient(90deg, #141b2d 0%, #434957 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          letterSpacing: "-1px"
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="h5"
        sx={{
          color: theme.palette.mode === 'dark' ? "#9A67ED" : "#7949E7",
          fontWeight: "600",
          letterSpacing: "0.5px",
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
